import React from 'react';
import { Container } from 'react-bootstrap';
import { useStaticQuery, graphql } from 'gatsby';

import BlogCard from './blog-card';
// import PostPaginations from '../post-paginations';

const BlogPage = () => {
  const data = useStaticQuery(graphql`
    query BlogQuery {
      allStoryblokEntry(filter: { parent_id: { eq: 28905705 } }) {
        nodes {
          full_slug
          field_image_string
          field_intro_string
          field_title_string
          field_author_string
          published_at(formatString: "DD MMM")
        }
      }
    }
  `);

  return (
    <section className="news-page pt-120 pb-120">
      <Container>
        <div className="row">
          {data.allStoryblokEntry.nodes.map(
            (
              {
                full_slug,
                field_image_string,
                field_intro_string,
                field_title_string,
                field_author_string,
                published_at,
              },
              index,
            ) => (
              <div className="col-sm-4 mb-5">
                <BlogCard
                  key={index}
                  image={field_image_string}
                  title={field_title_string}
                  date={published_at}
                  text={field_intro_string}
                  link={`/${full_slug}`}
                  author={field_author_string}
                />
              </div>
            ),
          )}
        </div>
        {/* <PostPaginations /> */}
      </Container>
    </section>
  );
};

export default BlogPage;
